import { useAmplitudeTracker } from '@geovelo-frontends/commons';
import { useContext } from 'react';
import { useSearchParams } from 'react-router';

import { AppContext } from '../app/context';

import { getCurrentContract } from './employees';
import usePartnerGeogroupQuery from './use-partner-geogroup-query';

function useTracker() {
  const {
    partner: { current: currentPartner },
    user: { employee },
  } = useContext(AppContext);
  const { data: geogroup } = usePartnerGeogroupQuery(currentPartner);
  const contract = currentPartner && getCurrentContract(currentPartner);
  const [searchParams] = useSearchParams();
  const { trackEvent: _trackEvent } = useAmplitudeTracker();

  function trackEvent(
    name: 'Page Visited' | string,
    properties?: Record<string, string | string[] | number | number[] | boolean | undefined>,
  ) {
    const utm_source = searchParams.get('utm_source');

    _trackEvent(name, {
      partner_id: currentPartner?.id,
      partner_code: currentPartner?.code,
      contract_type: contract?.contractTemplate.code,
      group_id: geogroup?.id,
      employee_id: employee?.id,
      user_type: employee?.role || 'guest',
      utm_source,
      ...properties,
    });
  }

  return { trackEvent };
}

export default useTracker;
